import { render, staticRenderFns } from "./directorLogin.vue?vue&type=template&id=04fbc3d0&scoped=true&"
import script from "./directorLogin.vue?vue&type=script&lang=js&"
export * from "./directorLogin.vue?vue&type=script&lang=js&"
import style0 from "./directorLogin.vue?vue&type=style&index=0&id=04fbc3d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04fbc3d0",
  null
  
)

export default component.exports